import BaseEnumType from "../../common/base-enum-type";

const PatPoints = Object.freeze({
    OptionOne: { ...new BaseEnumType("1", "PAT Score (Option 1)"), value: 1 },
    OptionTwo: { ...new BaseEnumType("2", "PAT Score (Option 2)"), value: 2 },
    OptionThree: { ...new BaseEnumType("3", "PAT Score (Option 3)"), value: 3 }
});

export default PatPoints;
